"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShiftRequestStatus = void 0;
exports.instanceOfShiftRequestStatus = instanceOfShiftRequestStatus;
exports.ShiftRequestStatusFromJSON = ShiftRequestStatusFromJSON;
exports.ShiftRequestStatusFromJSONTyped = ShiftRequestStatusFromJSONTyped;
exports.ShiftRequestStatusToJSON = ShiftRequestStatusToJSON;
exports.ShiftRequestStatusToJSONTyped = ShiftRequestStatusToJSONTyped;
/**
 *
 * @export
 */
exports.ShiftRequestStatus = {
    Proposed: 'PROPOSED',
    Requested: 'REQUESTED',
    Accepted: 'ACCEPTED',
    Declined: 'DECLINED',
    Canceled: 'CANCELED',
    Withdrawn: 'WITHDRAWN'
};
function instanceOfShiftRequestStatus(value) {
    for (const key in exports.ShiftRequestStatus) {
        if (Object.prototype.hasOwnProperty.call(exports.ShiftRequestStatus, key)) {
            if (exports.ShiftRequestStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function ShiftRequestStatusFromJSON(json) {
    return ShiftRequestStatusFromJSONTyped(json, false);
}
function ShiftRequestStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function ShiftRequestStatusToJSON(value) {
    return value;
}
function ShiftRequestStatusToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=ShiftRequestStatus.js.map